// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoRecorder/style.css
// module id = 2702
// module chunks = 29